package main.kotlin.ui

import org.w3c.dom.Document

class ErrorView(document: Document, id:String) : Div(document,id)
{
}